define([
    "jquery",
    "underscore",
    "marionette",
    "select2",
], function ($, _, Marionette) {
    return Marionette.View.extend({
        el: '#header_layout',

        ui: {
            'flags': '#flags_popup',
            'closeFlags': '.close_flags_popup',
            'openFlags': '.open_flags_popup',
            'selectedAccountNo': '#selected_account_no',
            'selectedAccountNoTest': '.selected_account_no',

            'languageBtn': '.language-btn',
            'languageText': '.language-btn span',

            'mobileLangBtn': '.language-btn-m',
            'closeMenuBtn': '.m-close-btn',
            'mobileCloseBtn': '.close-btn',
            'openMenuBtn': '.boot-ac-open-menu',
            'slideHeading': '.boot-ac-slide-heading'
        },

        events: {
            'click @ui.closeFlags': 'toggleFlags',
            'click @ui.openFlags': 'toggleFlags',
            'change @ui.selectedAccountNo': 'toggleSelectAccount',
            'change @ui.selectedAccountNoTest': 'toggleSelectAccount',

            'click @ui.languageBtn': 'languageToggle',
            'click @ui.mobileLangBtn': 'languageBtnMobile',
            'click @ui.closeMenuBtn': 'closeBtn',
            'click @ui.mobileCloseBtn': 'mobileCloseBtn',
            'click @ui.openMenuBtn': 'bootAcOpenMenu'
        },

        initialize: function () {
            this.bindUIElements();

            // click anywhere to close language popup if it is opened
            // except popup area.
            $(document).mouseup(function (e) {
                const clickedTarget = e.currentTarget.activeElement.className;
                const flagPopupStatus = $('#flags_popup').hasClass('on') ? 'opened' : 'closed';

                if (flagPopupStatus == 'opened') {
                    if (clickedTarget != 'language-btn') {
                        $('#flags_popup').removeClass('on');
                    }

                }
            });
        },

        toggleFlags: function (e) {
            if (e) e.preventDefault();
            $('body').toggleClass('noscroll');
            this.ui.flags.toggle();
        },

        languageToggle: function () {
            this.ui.flags.toggleClass("on");
            this.ui.languageText.toggleClass('open');
        },

        languageBtnMobile: function () {
            this.ui.flags.addClass("on");

        },

        closeBtn: function () {
            this.ui.flags.removeClass("on");
        },

        mobileCloseBtn: function () {
            this.ui.slideHeading.removeClass("on");
        },

        bootAcOpenMenu: function () {
            this.ui.slideHeading.addClass("on");
        },

        toggleSelectAccount: function (e) {
            window.location = window.location.href.split('?')[0] + '?selected_account=' + $(e.target).val();
        },
    });
});